import { CouponCatalogApi } from 'api/ApiHelper';
import { useQuery } from '@tanstack/react-query';
import { couponCatalogQueryKey } from 'queries/couponCatalog/queryKeys';

export const useGetCouponsQuery = (couponIds: number[]) =>
  useQuery({
    queryKey: couponCatalogQueryKey.coupons(couponIds),
    queryFn: () => Promise.all(couponIds.map(couponId => CouponCatalogApi.getCoupon(couponId))),
    enabled: couponIds.length > 0,
  });
